import { SubAPI } from "./SubAPI";
export class Pricing extends SubAPI {
    list(props) { return this.fetcher.get("/api/pricing", props); }
    getZerosByCategory(props) { return this.fetcher.get("/api/pricing/zeros-by-category", props); }
    upsert(input) { return this.fetcher.post("/api/pricing/item", input); }
    listRiders(props) { return this.fetcher.get("/api/price-rider", props); }
    getProjectMarkups(props) { return this.fetcher.get("/api/pricing/project-markups", props); }
    updateProjectMarkups(props) { return this.fetcher.post("/api/pricing/project-markups", props); }
    getCostInOtherQuotes(props) { return this.fetcher.get("/api/pricing/cost-in-other-quotes", props); }
    priceLookup(props) { return this.fetcher.get("/api/pricing/price-lookup", props); }
    scaleSection(props) { return this.fetcher.post("/api/pricing/section-total-price", props); }
}
